<template>
  <div class="distribution-map-container">
    <div class="right-switch">显示场馆名称:
      <el-switch v-model="showMapLabel"></el-switch>
    </div>
    <el-tabs type="border-card">
      <el-tab-pane label="一层">
        <distribution-map-content :venueArr="venueArr1" bgName="bg_1"
                                  :showMapLabel="showMapLabel"></distribution-map-content>
      </el-tab-pane>
      <el-tab-pane label="二层">
        <distribution-map-content :venueArr="venueArr2" bgName="bg_2"
                                  :showMapLabel="showMapLabel"></distribution-map-content>
      </el-tab-pane>
      <el-tab-pane label="三层">
        <distribution-map-content :venueArr="venueArr3" bgName="bg_3"
                                  :showMapLabel="showMapLabel"></distribution-map-content>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import {distributionMap} from './constant/NavConstant'
  import {UPDATE_VENUE_PAGE_TYPE} from 'src/store/mutations-types'
  import DistributionMapContent from './DistributionMapContent'

  export default {
    data () {
      return {
        showMapLabel: true,
        venueArr1: [
          {
            label: '多媒体教室',
            sign: 'dmtjs',
            show: true
          },
          {
            label: '楼梯',
            sign: 'lt',
            show: true
          },
          {
            label: '综合馆',
            sign: 'zhg',
            show: true
          },
          {
            label: '乒乓球馆',
            sign: 'ppqg',
            show: true
          },
          {
            label: '健美操馆',
            sign: 'jmcg',
            show: true
          },
          {
            label: '体育舞蹈馆',
            sign: 'tywdg',
            show: true
          },
          {
            label: '体能训练馆',
            sign: 'tnxlg',
            show: true
          },
          {
            label: '主馆',
            sign: 'zg',
            show: true
          },
          {
            label: '体育学院办公区',
            sign: 'tyxybgq',
            show: true
          },
          {
            label: '运动员休息区',
            sign: 'ydyxxq',
            show: true
          },
          {
            label: '仓库',
            sign: 'ck',
            show: true
          },
          {
            label: '场馆设备间',
            sign: 'cgsbj',
            show: true
          }
        ],
        venueArr2: [
          {
            label: '体育学院办公区',
            sign: 'tyxybgq',
            show: true
          },
          {
            label: '羽毛球馆',
            sign: 'ymqg',
            show: true
          },
          {
            label: '多媒体教室',
            sign: 'dmtjs',
            show: true
          },
          {
            label: '瑜伽馆',
            sign: 'yjg',
            show: true
          },
          {
            label: '武术馆',
            sign: 'wsg',
            show: true
          },
          {
            label: '体育舞蹈馆',
            sign: 'tywdg',
            show: true
          },
          {
            label: '主馆看台',
            sign: 'zgkt',
            show: true
          },
          {
            label: '楼梯间',
            sign: 'ltj',
            show: true
          }
        ],
        venueArr3: [
          {
            label: '多功能教室 ',
            sign: 'dgnjs',
            show: true
          },
          {
            label: '武术馆',
            sign: 'wsg',
            show: true
          },
          {
            label: '健美操馆',
            sign: 'jmcg',
            show: true
          },
          {
            label: '体操馆',
            sign: 'tcg',
            show: true
          }
        ]
      }
    },
    components: {
      DistributionMapContent
    },
    mounted () {
      this.$nextTick(function () {
        this.$store.commit(UPDATE_VENUE_PAGE_TYPE, distributionMap)
      })
    },
    methods: {}
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/venue/DistributionMap.vue